const mergeMemberRecords = ({ currentMembers = [], nextMembers = [] } = {}) => {
  const mergedByIdentity = new Map();

  (Array.isArray(currentMembers) ? currentMembers : []).forEach((member) => {
    const identity = member?.userId || member?.email;

    if (!identity) {
      return;
    }

    mergedByIdentity.set(identity, member);
  });

  (Array.isArray(nextMembers) ? nextMembers : []).forEach((member) => {
    const identity = member?.userId || member?.email;

    if (!identity) {
      return;
    }

    const currentMember = mergedByIdentity.get(identity);

    mergedByIdentity.set(identity, currentMember && typeof currentMember === 'object' && member && typeof member === 'object' ? { ...currentMember, ...member } : member);
  });

  return Array.from(mergedByIdentity.values());
};

export default mergeMemberRecords;
